import { Component, Input, OnInit } from '@angular/core';
@Component({
  selector: 'app-remark-group',
  templateUrl: './remark-group.component.html',
  styleUrl: './remark-group.component.css',
})
export class RemarkGroupComponent implements OnInit {
  @Input() label = '';
  @Input() remarkReason = '';
  @Input() remarkBy = '';
  @Input() remarkAt = '';
  @Input() isRejected = false;

  ngOnInit(): void {}
}
